import { registerLocaleData } from "@angular/common";
import localeCs from "@angular/common/locales/cs";
import localeDa from "@angular/common/locales/da";
import localeDe from "@angular/common/locales/de";
import localeGr from "@angular/common/locales/el";
import localeEnCA from "@angular/common/locales/en-CA";
import localeEnGB from "@angular/common/locales/en-GB";
import localeEs from "@angular/common/locales/es";
import localeEsAr from "@angular/common/locales/es-AR";
import localeEsCL from "@angular/common/locales/es-CL";
import localeEsCo from "@angular/common/locales/es-CO";
import localeEsMX from "@angular/common/locales/es-MX";
import localeEsPE from "@angular/common/locales/es-PE";
import localeEsPY from "@angular/common/locales/es-PY";
import localeEt from "@angular/common/locales/et";
import localeFi from "@angular/common/locales/fi";
import localeFrBE from "@angular/common/locales/fr-BE";
import localeIs from "@angular/common/locales/is";
import localeIt from "@angular/common/locales/it";
import localeJa from "@angular/common/locales/ja";
import localeLV from "@angular/common/locales/lv";
import localeNb from "@angular/common/locales/nb";
import localeNl from "@angular/common/locales/nl";
import localeNlBE from "@angular/common/locales/nl-BE";
import localePl from "@angular/common/locales/pl";
import localePt from "@angular/common/locales/pt";
import localeRu from "@angular/common/locales/ru";
import localeSv from "@angular/common/locales/sv";
import localeTr from "@angular/common/locales/tr";

export function registerAllLocaleData() {
	registerLocaleData(localeCs);
	registerLocaleData(localeDa);
	registerLocaleData(localeDe);
	registerLocaleData(localeGr);
	registerLocaleData(localeEnCA);
	registerLocaleData(localeEnGB);
	registerLocaleData(localeEs);
	registerLocaleData(localeEsAr);
	registerLocaleData(localeEsCL);
	registerLocaleData(localeEsCo);
	registerLocaleData(localeEsPE);
	registerLocaleData(localeEsPY);
	registerLocaleData(localeEsMX);
	registerLocaleData(localeEt);
	registerLocaleData(localeFi);
	registerLocaleData(localeIs);
	registerLocaleData(localeIt);
	registerLocaleData(localeJa);
	registerLocaleData(localeLV);
	registerLocaleData(localeNb);
	registerLocaleData(localePl);
	registerLocaleData(localePt);
	registerLocaleData(localeRu);
	registerLocaleData(localeSv);
	registerLocaleData(localeTr);
	registerLocaleData(localeNl);
	registerLocaleData(localeFrBE);
	registerLocaleData(localeNlBE);
}
